<phdsoft-window [options]="optionsWindow" (ok)="save()">
  <ng-container header style="background-color: transparent;">
    <div>
      Change Explanation
    </div>
  </ng-container>
  <div content>
    <textarea matInput [(ngModel)]="textJustification">

    </textarea>
  </div>
  <!-- <ng-container footer *ngIf="showFooter">
    {{ footerText }}
  </ng-container> -->
</phdsoft-window>
